let _config = null
let _version = null
let _loadPromise = null

// The deployment mounts global-values PRODUCT_VERSION at /static/config/version
// (refreshed every release); it exists purely as the observability release tag.
async function fetchRuntimeVersion () {
  try {
    // Absolute path: a relative one resolves against deep SPA routes, where
    // the nginx fallback answers with index.html (HTTP 200). The shape check
    // keeps any such document out of the version tag.
    const response = await fetch('/static/config/version')
    if (!response.ok) return ''
    const text = (await response.text()).trim()
    return /^[0-9A-Za-z][\w.+-]{0,63}$/.test(text) ? text : ''
  } catch (e) {
    return ''
  }
}

export async function loadRuntimeConfig () {
  if (_config) return _config
  if (_loadPromise) return _loadPromise

  _loadPromise = (async () => {
    const versionPromise = fetchRuntimeVersion()
    try {
      const response = await fetch('/static/config/settings.json')
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      _config = await response.json()
      return _config
    } catch (e) {
      console.warn(
        '[runtimeConfig] Failed to load settings.json, falling back to process.env'
      )
      return {}
    } finally {
      _version = await versionPromise
      _loadPromise = null
    }
  })()

  return _loadPromise
}

export function getRuntimeVersion () {
  return _version || undefined
}

export function getConfig (key, fallback) {
  const envFallback =
    typeof fallback !== 'undefined' ? fallback : process.env[key]
  // Runtime values live under a top-level `config` object in settings.json
  // (mirrors kronos), so read from there rather than the document root.
  const settings = _config && _config.config
  if (!settings) return envFallback
  return settings[key] !== undefined ? settings[key] : envFallback
}



// WEBPACK FOOTER //
// ./src/services/runtimeConfig.js